import React, {Component} from 'react';
import {connect} from 'react-redux';
import {displayToba, requestAcceptToba, requestToba} from "../../actions/user";
import Toba from "../../components/toba";
import {closeTobaRejectModal, openTobaRejectModal, requestTobaMessage} from "../../actions/toba";
import Button from "../../components/button";
import GeneralSVG from "../../components/generalSVG";
// import download from "in-browser-download";
import { goBack } from 'connected-react-router';
import {_getFileFromBase64} from "../../helpers/functions";

class TobaHOC extends Component {

    componentDidMount(){
        this.props.requestToba(this.props.user.loggedInUser.agentId);
        this.props.requestTobaMessage();
    }

    // _getFileFromBase64 = (documentToDownload) => {
    //     download(documentToDownload.encodedFile, documentToDownload.name, documentToDownload.fileType, 'base64');
    // };

    _getTobaRejectModalContent = () => {
        return (
            <div>
                <p>
                    {'Please note that our Terms of Business Agreement must be accepted if you wish ' +
                    'to apply for an ATE insurance policy.'}
                </p>
                <p>
                    {'Are you sure you would like to reject the TOBA?'}
                </p>
                <div>
                    <Button clickHandler={() => this.props.postAcceptToba(this.props.user.toba.id)} wrapper="btn-wrapper"
                            btnType="button" btnStyle={'btn btn-primary btn-xs sharp yellow'}
                            label="Accept TOBA"
                    />
                    <Button clickHandler={()=> this.props.closeTobaRejectModal()} wrapper="btn-wrapper"
                            btnType="button" btnStyle={'btn btn-primary btn-xs sharp white'}
                            label="Cancel"
                    />
                    <div onClick={this.props.toggleToba} className="toba-reject-wrapper">
                        <GeneralSVG
                            SvgWrapper="arag__button__float"
                            Label={'Reject TOBA'}
                            Svg={<svg xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 9.6 16"><title>Asset
                                2</title>
                                <g id="Layer_2" data-name="Layer 2">
                                    <g id="Layer_1-2"
                                       data-name="Layer 1">
                                        <path
                                            d="M9.6,8.08a1.63,1.63,0,0,1-.48,1.16L2.81,15.53A1.63,1.63,0,0,1,.52,13.21L5.68,8.07.47,2.78A1.63,1.63,0,1,1,2.78.49L9.13,6.94A1.63,1.63,0,0,1,9.6,8.08Z"/>
                                    </g>
                                </g>
                            </svg>}
                        />
                    </div>
                </div>
            </div>
        )
    };

    render(){
        return (
            <Toba
                locationPathName={this.props.locationPathName}
                goBack={this.props.goBack}
                _getFileFromBase64={_getFileFromBase64}
                tobaRejectModalContent={this._getTobaRejectModalContent()}
                user={this.props.user}
                postAcceptToba={this.props.postAcceptToba}
                toggleToba={this.props.toggleToba}
                _openTobaRejectModal={this.props.openTobaRejectModal}
                _closeTobaRejectModal={this.props.closeTobaRejectModal}
            />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
        locationPathName: state.router.location.pathname
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        requestToba: (agentId) => {
            dispatch(requestToba(agentId))
        },
        postAcceptToba: (tobaId) => {
            dispatch(requestAcceptToba(tobaId))
        },
        toggleToba: () => {
            dispatch(displayToba())
        },
        openTobaRejectModal: (payload) => {
            dispatch(openTobaRejectModal())
        },
        closeTobaRejectModal: (payload) => {
            dispatch(closeTobaRejectModal())
        },
        goBack: () => {
            dispatch(goBack())
        },
        requestTobaMessage: () => {
            dispatch(requestTobaMessage())
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(TobaHOC);
